<template>
  <div
    class="product-selector-box"
    :class="{ active: isOpen, 'bottom-border-hidden': hideBottomBorder }"
  >
    <div class="box-heading" @click="handleBoxOpening" ref="heading">
      <div class="heading-detail">
        <span class="panel-num">{{ optionNumber }}</span>
        <span class="panel-title">{{ optionTitle }}</span>
      </div>
      <span class="panel-indicator">
        <!-- <slot name="heading-detail"></slot> -->
        <svg width="17" height="10" viewBox="0 0 17 10" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M16.7226 0.293683C16.6349 0.200589 16.5307 0.12673 16.4159 0.0763352C16.3012 0.0259403 16.1782 0 16.054 0C15.9298 0 15.8068 0.0259403 15.6921 0.0763352C15.5774 0.12673 15.4732 0.200589 15.3855 0.293683L8.49975 7.58508L1.61403 0.293683C1.43672 0.105976 1.19623 0.000524155 0.945477 0.000524155C0.694721 0.000524155 0.454235 0.105976 0.276924 0.293683C0.0996125 0.481389 0 0.735973 0 1.00143C0 1.26689 0.0996125 1.52147 0.276924 1.70918L7.8312 9.70632C7.91892 9.79941 8.02312 9.87327 8.13784 9.92367C8.25256 9.97406 8.37555 10 8.49975 10C8.62396 10 8.74695 9.97406 8.86167 9.92367C8.97639 9.87327 9.08059 9.79941 9.16831 9.70632L16.7226 1.70918C16.8105 1.61632 16.8803 1.50601 16.9279 1.38456C16.9755 1.26311 17 1.13292 17 1.00143C17 0.869942 16.9755 0.739746 16.9279 0.618299C16.8803 0.496852 16.8105 0.386541 16.7226 0.293683Z" fill="#121212" fill-opacity="0.75"/>
        </svg>

      </span>
    </div>
    <div class="box-content" ref="boxContent">
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: "ProductSelectorBox",
  props: {
    optionNumber: {
      type: [Number, String],
      default: 0,
    },
    optionTitle: {
      type: String,
      default: "Product Option",
    },
    hideBottomBorder: {
      type: Boolean,
      default: true,
    },
    productType: String,
    activeByDefault: Boolean,
    boxType: {
      type: String,
      default: "",
    }
  },
  data: function () {
    return {
      isOpen: false,
      boxHeight: 0,
    };
  },
  mounted() {
    if (this.activeByDefault) {
      this.$refs.boxContent.style.maxHeight = "inherit";
      this.isOpen = true;
      // this.handleBoxOpening();
    }
    if (window) {
      window.addEventListener("resize", this.updateBoxSize);
    }
    if (this.$refs.boxContent && this.$refs.heading) {
      this.$refs.boxContent.addEventListener(
        "transitionend",
        this.maybeScrollToHeading
      );
    }
  },
  methods: {
    maybeUpdateBoxSize() {
      const newBoxHeight = this.$refs.boxContent.scrollHeight;
      if (newBoxHeight !== this.boxHeight) {
        this.updateBoxSize();
        // if (!this.activeByDefault && this.isOpen) {
        // window.scrollTo({
        //   top: this.$refs.heading.offsetTop,
        //   behavior: "smooth",
        // });
      }
    },
    updateBoxSize() {
      if (this.isOpen) {
        const newBoxHeight = this.$refs.boxContent.scrollHeight;
        this.boxHeight = newBoxHeight;
        this.$refs.boxContent.style.maxHeight = newBoxHeight + "px";
      }
    },
    closeBox() {
      this.$refs.boxContent.style.maxHeight = null;
      this.isOpen = false;
    },
    openBox() {
      this.isOpen = true;
      this.updateBoxSize();
      document.dispatchEvent(new CustomEvent("td:box-selected", {
        detail: {
          type: this.boxType
        }
      }))
    },
    maybeScrollToHeading(e) {
      // Only should scroll to the top of secondary ones on open
      if (!this.activeByDefault && this.isOpen) {
        if (this.$refs.boxContent == e.target) {
          window.scrollTo({
            top: this.$refs.heading.offsetTop,
            behavior: "smooth",
          });
        }
      }
    },
    handleBoxOpening() {
      if (this.isOpen) {
        this.closeBox();
      } else {
        this.openBox();
      }
      this.$emit("box-state-changed");
    },
  }
};
</script>
<style scoped>
.product-selector-box {
  border-top: 1px solid #cbc8c3;
  margin: 0 20px;
}
.panel-num {
  font-size: 24px;
  color: #31382d;;
}
.box-heading {
  padding: 1.5rem 0;
  /* padding-left: 1.6rem; */
  margin: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  -webkit-user-select: none; /* Safari */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* IE10+/Edge */
  user-select: none; /* Standard */
  font-weight: 500;
  font-size: 18px;
  line-height: 150%;
  letter-spacing: 0.25px;
  text-decoration: none;
  text-align: center;
  position: relative;
}
.panel-title {
  text-align: left;
  margin: 0 10px;
}
.heading-detail {
  display: flex;
  align-items: center;
}
.panel-indicator {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
}
.box-content {
  height: auto;
  overflow: hidden;
  display: block;
  max-height: 0;
  transition: max-height 0.4s ease-in-out;
  
}
.product-selector-box.active .box-content {
  padding-bottom: 22px;
}
.product-selector-box svg {
  transition: 0.4s ease-in-out;
}
.product-selector-box.active svg {
  transform: rotate(180deg);
}
.bottom-border-hidden {
  border-bottom: none;
}
@media screen and (min-width: 768px) {
  .product-selector-box {
    border: 1px solid #cbc8c3;
    border-bottom: 0;
    margin: 0;
  }
  .box-heading {
    padding: 20px 24px;
    font-size: 24px;
  }
  .panel-num {
    font-size: 48px;
  }
  .box-content {
    padding: 0 24px;
  }
}
</style>
